import React from 'react';
import { useLoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import { Box } from '@mui/material';

import getConfig from 'next/config';
type GoogleMapsProps = {
  lat: number;
  long: number;
  zoom?: number;
};
const mapLocation = '/icons/cinema/mapLocation.svg';

const GoogleMaps = (props: GoogleMapsProps) => {
  // https://react-google-maps-api-docs.netlify.app/
  const { lat, long, zoom } = props;
  const { publicRuntimeConfig } = getConfig();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: publicRuntimeConfig.mapKey,
  });

  const center = { lat: lat, lng: long };
  return isLoaded ? (
    <GoogleMap
      center={center}
      zoom={zoom ?? 8}
      mapContainerStyle={{
        height: '100%',
        width: '100%',
        borderRadius: '20px',
        overflow: 'hidden',
      }}
      options={{
        zoomControlOptions: { position: 9.0 }, // === google.map.BOTTOM_RIGHT
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      <Marker position={center} icon={mapLocation} />
    </GoogleMap>
  ) : (
    <Box />
  );
};

export default GoogleMaps;
